module.exports = __webpack_public_path__ + "img/2.100ce634.svg";